import React from 'react';
import { ResetStatusData } from '@/hooks/submission_forms/useSubmissionTemplateVersion';

interface ResetToProdButtonProps {
  status: ResetStatusData | null;
  isInFlight: boolean;
  onClick: () => void;
  label: string;
  inProgressLabel: string;
  title: string;
}

// Shared markup for the per-template and "reset all" reset-to-prod buttons —
// gated identically (configured && !production) and disabled identically
// (isInFlight covers both a client-side in-flight trigger and a
// server-reported queued/running job).
const ResetToProdButton: React.FC<ResetToProdButtonProps> = ({
  status,
  isInFlight,
  onClick,
  label,
  inProgressLabel,
  title,
}) => {
  if (!status?.configured || status.production) return null;

  return (
    <button
      onClick={onClick}
      disabled={isInFlight}
      title={title}
      className="text-xs text-amber-700 hover:text-amber-900 border border-amber-300 bg-amber-50 rounded px-3 py-1.5 disabled:opacity-40"
    >
      {isInFlight ? inProgressLabel : label}
    </button>
  );
};

export default ResetToProdButton;
